import $ from 'jquery';
import { directiveSettings } from '../../utils/parse';

export default function filterDirective(context=document.body) {
	const $context = $(context);

	$context.find('[sw-filter]').each(function() {
		const $filter = $(this);
		const json = $filter.attr('sw-filter');
		const settings = directiveSettings(json, {
			name: '',
		}, 'name');
		const itemAttr = `sw-filter-${settings.name}`;
		const $items = $(`[${itemAttr}]`);
		const $filterFields = $filter.find('input');

		$filterFields.on('change', function() {
			const $field = $(this);

			if ($field.attr('type') === 'radio' && $field.is(':checked')) {
				const filterVal = $field.val();

				if (filterVal !== 'showAll') {
					$items.each(function() {
						const $item = $(this);
						const isHidden = $item.hasClass('+hidden');
						const isSelected = $item.attr(itemAttr) === filterVal;

						if (isSelected && isHidden) {
							$item.removeClass('+hidden');
						} else if (!isSelected && !isHidden) {
							$item.addClass('+hidden');
						}
					});
				} else {
					$items.removeClass('+hidden');
				}
			}
		});
	});
}



// WEBPACK FOOTER //
// ./source/scripts/directives/action/filter.js